module.exports = __webpack_public_path__ + "media/images/hiring-manager-example-13bdfa74.png";